import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { PageHeader } from "../../layout/AppLayout";
import { ErpTable } from "../../components/erp";
import { errorText } from "../../api/client";
import { salesApi, ClearingAgentRow } from "./api";

/** Port of ApiV2/Exports/Controller/ClearingAgentController.php (v3/Sales/ClearingAgentPage.php) -
 * export/clearing tracking list, joined against ScrmCustomInvoices/ScrmISFDetails/ScrmNotifyparty.
 * FromDate/ToDate are required (safety guard, same pattern used for ColdStore stock/stock-out -
 * the unfiltered join scans the full live ~5,965-row ScrmCustomInvoices set). */
export default function ClearingAgentPage() {
  const today = new Date().toISOString().slice(0, 10);
  const yearAgo = new Date(Date.now() - 365 * 86400000).toISOString().slice(0, 10);
  const [filters, setFilters] = useState({ FromDate: yearAgo, ToDate: today });
  const [searched, setSearched] = useState(true);
  const list = useQuery({ queryKey: ["sales", "clearing-agent", filters], enabled: searched, queryFn: () => salesApi.clearingAgentStatus(filters) });

  return (
    <>
      <PageHeader title="Clearing Agent Status" location="Sales" />
      <div className="card mb-3"><div className="card-body">
        <div className="row">
          <div className="col-md-3 mb-3"><label className="form-label">From Date</label>
            <input type="date" className="form-control" data-testid="clearing-from-date" value={filters.FromDate}
              onChange={(e) => setFilters((s) => ({ ...s, FromDate: e.target.value }))} /></div>
          <div className="col-md-3 mb-3"><label className="form-label">To Date</label>
            <input type="date" className="form-control" data-testid="clearing-to-date" value={filters.ToDate}
              onChange={(e) => setFilters((s) => ({ ...s, ToDate: e.target.value }))} /></div>
          <div className="col-md-3 mb-3 d-flex align-items-end">
            <button className="btn btn-primary w-100" data-testid="clearing-search-btn" onClick={() => setSearched(true)}>Search</button></div>
        </div>
      </div></div>
      <div className="card"><div className="card-body">
        <div className="mb-3"><strong data-testid="clearing-total-count">{list.data?.TotalCount ?? 0} shipments</strong></div>
        <ErpTable<ClearingAgentRow> testId="clearing-agent-table" loading={list.isLoading} error={list.isError ? errorText(list.error) : null}
          rows={list.data?.Data || []} columns={[
            { key: "SNO", title: "#" }, { key: "InvNo", title: "Invoice No" }, { key: "Buyer", title: "Buyer" },
            { key: "BLNo", title: "BL No" }, { key: "PortOfDischarge", title: "Port of Discharge" }, { key: "NotifypartyName", title: "Notify Party" },
          ]} />
      </div></div>
    </>
  );
}
